export default __webpack_public_path__ + "static/media/pic11.a8b78b2b.jpg";